// extracted by mini-css-extract-plugin
export default {"entitySelectionModal":"entitySelection_entitySelectionModal__4eJm5"};